module.exports = __webpack_public_path__ + "4a5f2b7be22d7470aea82f9955c391f1.pdf";